import type { ReloadFormResponse } from 'apiConnector/secondary-market/shared/form';
import type { ReferentialFormResponse } from 'apiConnector/secondary-market/shared/referential';
import type { Custodian } from 'models/custodian';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { WorkspaceType } from 'state/workspaces/model';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';
import type { HttpErrorKind } from 'utils/errors/errors';

export type OrderActionType = 'LIMIT_ORDER' | 'LIVE' | 'CP_ORDER';
export const secondaryMarketActionsFactory = <
  Referential extends ReferentialFormResponse,
  ActionType extends Exclude<OrderActionType, 'CP_ORDER'>,
>(
  actionType: ActionType,
) => ({
  initFormFetchRequested: (
    tabId: string,
    bcsProductKey: BcsProductKey,
    tradeWay?: TradeWay,
    client?: ISalesCounterpart,
    custodian?: Custodian,
  ) => ({
    type: `SECONDARY_MARKET_${actionType}_INIT_FORM_FETCH_REQUESTED` as const,
    tabId,
    workspace: 'secondaryMarketQuotes' as WorkspaceType,
    bcsProductKey,
    tradeWay,
    client,
    custodian,
  }),
  initFormFetched: (tabId: string, response: ReloadFormResponse<Referential>) => ({
    type: `SECONDARY_MARKET_${actionType}_INIT_FORM_FETCHED` as const,
    tabId,
    workspace: 'secondaryMarketQuotes' as WorkspaceType,
    response,
  }),
  initFormFetchedFailed: (tabId: string, message?: string, errorKind?: HttpErrorKind) => ({
    type: `SECONDARY_MARKET_${actionType}_INIT_FORM_FETCH_FAILED` as const,
    workspace: 'secondaryMarketQuotes' as WorkspaceType,
    tabId,
    message,
    errorKind,
  }),
  secondaryMarketReloadRequestedByOrderId: (orderId: string) => {
    return {
      type: `SECONDARY_MARKET_${actionType}_RELOAD_REQUESTED_BY_ORDER_ID` as const,
      orderId,
    };
  },
});
